<template>
 <div class="item pt16 pb16" >
    <h4 class="mb8">签约信息</h4>
    <Row>
      <Col span="8">合同编号：<span class="info">BJZYD051874230</span></Col>
      <Col span="8">房间数量：<span class="info">100</span></Col>
      <Col span="8">床位数量：<span class="info">100</span></Col>
      <Col span="8">租约类型：<span class="info">年租</span></Col>
      <Col span="8">签约类型：<span class="info">新签/续约</span></Col>
      <Col span="8">签约日期：<span class="info">2018-07-31</span></Col>
      <Col span="8">起租日期：<span class="info">2018-07-31</span></Col>
      <Col span="8">到期日期：<span class="info">2018-07-31</span></Col>
      <Col span="8">付款方式：<span class="info">一次性付清</span></Col>
      <Col span="8">签约ZO：<span class="info">陈浩</span></Col>
    </Row>
  </div>

</template>
 
<script type="text/ecmascript-6">
export default {
 data () {
 return {
   data:{
     type:Object,
     default: () => {
       return {
         title:'签约信息',
         content:[{
           
         },{},{}]
       }
     }
   }
 
 };
 }
}
</script>
 
<style lang="css" scoped>
 
</style>